import styled from 'styled-components';

export const Form = styled.form`
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 50px;
  text-align: center;
  span {
    margin-bottom: 1rem;
  }
  input {
    font-size: 1.4rem;
    background-color: #eee;
    border: none;
    padding: 12px 15px;
    margin: 8px 0;
    width: 100%;
    border-radius: 6px;
  }
`;

export const ChangeMethod = styled.span`
  font-size: 1.2rem;
  margin-top: 1rem;
  margin-bottom: 0;
  color: var(--grey);
  transition: all 0.2s;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
    color: var(--accent);
  }
`;
